<template>
  <v-container fluid>
    <v-card>
      <v-card-title class=""> Cuentas</v-card-title>
      <v-row>
        <v-col cols="auto">
          <v-btn
            :class="[
              {
                'disabled-button': currentView != 'CuentasPorPagarView',
                'enabled-button': currentView === 'CuentasPorPagarView',
              },
              'mr-1',
              'ml-3',
              'mb-7',
            ]"
            color="primary"
            @click="currentView = 'CuentasPorPagarView'"
          >
            Por Pagar
          </v-btn>
          <v-btn
            :class="[
              {
                'disabled-button': currentView != 'CuentasPagadasView',
                'enabled-button': currentView === 'CuentasPagadasView',
              },
              'mr-2',
              'ml-2',
              'mb-7',
            ]"
            color="primary"
            @click="currentView = 'CuentasPagadasView'"
          >
            Pagados
          </v-btn>
        </v-col>
      </v-row>

      <v-card-title
        v-if="currentView === 'CuentasPorPagarView'"
        class="teal lighten-3 accent-4 white--text"
      >
        Cuentas por pagar</v-card-title
      >
      <v-tabs
        v-if="currentView === 'CuentasPorPagarView'"
        v-model="selectedTab"
        color="teal lighten-3 accent-4"
        centered
        class="mt-3"
      >
        <v-tab
          v-for="sucursal in itemsSucursalesDisponibles"
          :key="sucursal.sucursal"
        >
          <div>
            {{ sucursal.sucursal }}
          </div>
        </v-tab>
        <v-tab-item
          :disabled="true"
          v-for="(sucursal, index) in itemsSucursalesDisponibles"
          :key="index"
        >
          <v-row class="pa-5">
            <v-col cols="4"><v-btn>Descargar</v-btn></v-col>
            <v-col cols="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Búsqueda"
                single-line
                hide-details
                class="ml-4"
              ></v-text-field>
            </v-col>
            <v-col cols="4" class="text-right">
              <v-btn
                icon
                color="teal lighten-2 accent-4"
                @click="dialogXML = true"
                large
                text
                ><v-icon>mdi-file-xml-box</v-icon></v-btn
              >
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="sucursal.cuentas"
            :search="search"
            :item-class="itemRowBackground"
            :footer-props="{
              'items-per-page-text': 'Cuentas por página',
              'items-per-page-all-text': 'Todos',
            }"
            :header-props="{ 'sort-by-text': 'Ordenar por' }"
            no-data-text="No se encontraron cuentas por pagar"
            no-results-text="No se encontraron cuentas por pagar"
            class="color-bg-table"
          >
            <template v-slot:[`item.id`]="{ item }">
              <div class="d-flex align-center gap-2 flex-wrap">
                <span
                  v-if="expandedIds[item.id]"
                  class="monospace"
                  style="word-break: break-all"
                  >{{ item.id }}</span
                >
                <span v-else class="monospace"
                  >{{ item.id.substring(0, 8) }}...</span
                >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      text
                      color="teal lighten-2 accent-4"
                      @click.prevent="expandirItem(item.id)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>{{
                        expandedIds[item.id]
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    expandedIds[item.id] ? "Contraer" : "Expandir"
                  }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      text
                      color="teal lighten-2 accent-4"
                      @click.prevent="copiarAlPortapapeles(item.id)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copiar</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:[`item.total_factura`]="{ item }">
              {{ formatearPrecio("$" + item.total_factura) }}
            </template>
            <template v-slot:[`item.orden_de_compra`]="{ item }">
              <v-row no gutters>
                <v-col cols="6" class="d-flex align-center">
                  <div v-if="item.oc_pdf === false">
                    {{ item.orden_de_compra }}
                  </div>
                  <a
                    href="#"
                    v-if="item.oc_pdf === true"
                    @click.prevent="
                      abrirPdf(item.id, 'oc', item.orden_de_compra)
                    "
                  >
                    {{ item.orden_de_compra }}
                  </a>
                </v-col>
                <v-col cols="6" class="d-flex justify-end align-center">
                  <v-btn
                    icon
                    text
                    color="teal lighten-2 accent-4"
                    @click.prevent="subirPdfDialog(item, 'oc')"
                    ><v-icon>{{
                      item.oc_pdf === false
                        ? "mdi-file-upload"
                        : "mdi-file-edit"
                    }}</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.folio_factura`]="{ item }">
              <v-row no-gutters>
                <!-- Columna para mostrar el folio de la factura -->
                <v-col cols="6" class="d-flex align-center">
                  <div
                    v-if="
                      item.factura_pdf === false && item.folio_factura !== ''
                    "
                  >
                    {{ item.folio_factura }}
                  </div>
                  <a
                    v-if="item.factura_pdf === true"
                    href="#"
                    @click.prevent="abrirPdf(item.id, 'oc', item.folio_factura)"
                  >
                    {{ item.folio_factura }}
                  </a>
                </v-col>

                <!-- Columna para el botón de subir o editar PDF -->
                <v-col cols="6" class="d-flex justify-end align-center">
                  <v-btn
                    icon
                    text
                    color="teal lighten-2 accent-4"
                    @click.prevent="subirPdfDialog(item, 'factura')"
                  >
                    <v-icon>
                      {{
                        item.factura_pdf === false
                          ? "mdi-file-upload"
                          : "mdi-file-edit"
                      }}
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.boleta_pdf`]="{ item }">
              <v-row>
                <v-col cols="6">
                  <v-btn
                    icon
                    text
                    color="teal lighten-2 accent-4"
                    @click.prevent="subirPdfDialog(item, 'boleta')"
                  >
                    <v-icon>{{
                      item.boleta_pdf ? "mdi-file-edit" : "mdi-file-upload"
                    }}</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    v-if="item.boleta_pdf === true"
                    icon
                    text
                    color="teal lighten-2 accent-4"
                    @click="abrirPdf(item.id, 'boleta')"
                    ><v-icon>mdi-eye</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.pagado`]="{ item }">
              <v-select
                v-model="item.pagado"
                :items="estatusItems"
                item-text="text"
                item-value="value"
                hide-details
                dense
                class="tamaño-select-estatus"
                @change="cambiarEstatus(item)"
              >
                <!-- Opciones del dropdown -->
                <template v-slot:item="{ item }">
                  <v-chip
                    :color="item.value === true ? 'green' : 'orange'"
                    dark
                    small
                  >
                    {{ item.text }}
                  </v-chip>
                </template>

                <!-- Valor seleccionado -->
                <template v-slot:selection="{ item }">
                  <v-chip
                    :color="item.value === true ? 'green' : 'orange'"
                    dark
                    small
                  >
                    {{ item.text }}
                  </v-chip>
                </template>
              </v-select>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs>
      <v-dialog v-model="dialogXML" max-width="600px">
        <v-card>
          <v-card-title class="teal lighten-3 accent-4 white--text">
            Subir XML de Compra
          </v-card-title>
          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="6">
                <v-file-input
                  v-model="archivoXML"
                  label="Selecciona el archivo XML"
                  accept=".xml"
                  outlined
                  @change="PreviewXMLFile"
                ></v-file-input>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="ordenDeCompra"
                  label="Orden de compra"
                  outlined
                  append-icon="mdi-file-document-outline"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <div v-if="previewXML" class="pa-4" outlined>
            <b>Estos son los datos del XML que se van a cargar:</b>
            <v-row dense class="mt-3">
              <v-col cols="6"
                ><strong>Proveedor:</strong> {{ previewXML.proveedor }}</v-col
              >
              <v-col cols="6"
                ><strong>Folio:</strong> {{ previewXML.folio }}</v-col
              >

              <v-col cols="6"
                ><strong>Total:</strong> ${{ previewXML.total }}</v-col
              >
              <v-col cols="6"
                ><strong>Fecha:</strong> {{ previewXML.fecha }}</v-col
              >

              <v-col cols="12">
                <v-chip color="green" text-color="white" small>
                  CFDI válido
                </v-chip>
              </v-col>
              <div class="mt-2">¿Son correctos estos datos?</div>
            </v-row>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogXML = false"
              >Cancelar</v-btn
            >
            <v-btn
              color="green darken-1"
              text
              :disabled="!previewXML"
              :loading="loading"
              @click="cargarXML"
              >{{ previewXML ? "Son correctos, Subir" : "Subir" }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogPDF" max-width="600px">
        <v-card>
          <v-card-title class="teal lighten-3 accent-4 white--text">
            Subir PDF de {{ tipoPDF }}
          </v-card-title>

          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="12">
                <v-file-input
                  v-model="archivoPDF"
                  label="Selecciona el archivo PDF"
                  accept=".pdf"
                  outlined
                  chips
                  multiple
                  @change="previewPDFFile"
                ></v-file-input>
              </v-col>
            </v-row>

            <!-- Previsualización simple -->
            <div v-if="previewPDF" class="pa-4">
              <div v-for="pdfs in previewPDF" :key="pdfs.name">
                <v-chip color="blue" text-color="white" small>
                  {{ pdfs.name }}
                </v-chip>
              </div>

              <!-- Mini visor PDF opcional -->
              <div v-if="mostrarPDF" class="mt-3" style="height: 300px">
                <vue-pdf-app v-if="pdfUrlPreview" :pdf="pdfUrlPreview" />
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="cerrarDialogPDF">
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :disabled="!previewPDF"
              :loading="loadingPDF"
              @click="subirPDF()"
            >
              Subir PDF
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog para visor PDF -->
      <v-dialog v-model="dialogPdfVisor" max-width="1000px">
        <v-card>
          <v-card-title>
            PDF de: {{ name }}
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogPdfVisor = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <!-- Visor PDF con vue-pdf-app -->
            <vue-pdf-app
              :pdf="pdfUrl"
              :file-name="`${name}.pdf`"
              style="height: 80vh"
              theme="light"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
    <v-alert
      v-if="alertaCopiado"
      type="success"
      class="alerta-copiado"
      dense
      elevation="4"
    >
      ID copiado al portapapeles con éxito
    </v-alert>
    <CuentasPagadasView v-if="currentView === 'CuentasPagadasView'" />
  </v-container>
</template>

<script>
import axios from "axios";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import { mapGetters } from "vuex";
import CuentasPagadasView from "./CuentasPagadasView.vue";
import { PDFDocument } from "pdf-lib";

export default {
  data() {
    return {
      unirPdfs: null,
      search: "",
      currentView: "CuentasPorPagarView",
      loading: false,
      selectedTab: 0,
      itemsSucursalesDisponibles: [
        { sucursal: "Mexicali" },
        { sucursal: "Tijuana" },
        { sucursal: "Ensenada" },
        { sucursal: "LaPaz" },
        { sucursal: "Obregon" },
        { sucursal: "Hermosillo" },
      ],
      items: [
        {
          id: 1,
          proveedor: "ELANCO",
          monto_a_pagar: 500,
          orden_compra: "OC-8058",
          folio_factura: "F-123",
          compra: "180010001",
          boleta: "Boleta 1",
          fecha_vencimiento: "2026-01-31",
          compraPdf: "/OC 8058.pdf",
          boletaSubida: false,
        },
      ],
      dialogXML: false,
      archivoXML: null,
      previewXML: null,
      estatusItems: [
        {
          text: "Pagado",
          value: true,
        },
        {
          text: "Pendiente",
          value: false,
        },
      ],
      pdfUrl: "",
      pdfUrlPreview: "",
      dialogPdfVisor: false,
      dialogPDF: false,
      archivoPDF: [],
      previewPDF: [],
      mostrarPDF: false,
      loadingPDF: false,
      currentItem: null,
      expandedIds: {},
      headers: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Proveedor",
          value: "razon_social_proveedor",
        },
        {
          text: "Monto a Pagar",
          value: "total_factura",
        },
        {
          text: "Orden de compra",
          value: "orden_de_compra",
        },
        {
          text: "Folio - Factura",
          value: "folio_factura",
        },
        {
          text: "Compra",
          value: "compras",
        },
        {
          text: "Boleta",
          value: "boleta_pdf",
        },
        {
          text: "Fecha de vencimiento",
          value: "fecha_vencimiento",
        },
        {
          text: "Estatus",
          value: "pagado",
        },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],

      ordenSucursales: [
        "Mexicali",
        "Tijuana",
        "Ensenada",
        "LaPaz",
        "Obregon",
        "Hermosillo",
      ],
      sucursal: "",
      ordenDeCompra: "",
      alertaCopiado: false,
      tipoPDF: null,
      name: "",
    };
  },

  methods: {
    async abrirPdf(uuid, tipo, name) {
      try {
        const response = await axios.get(
          `/cuentas/get_pdf?uuid=${uuid}&tipo=${tipo}`,
          {
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], {
          type: "application/pdf",
        });

        this.pdfUrl = URL.createObjectURL(blob);
        this.dialogPdfVisor = true;
        this.name = name;
      } catch (error) {
        console.error(error);
        alert("No se pudo abrir el PDF");
      }
    },

    subirPdfDialog(item, tipo) {
      this.currentItem = item;
      this.tipoPDF = tipo;
      this.dialogPDF = true;
      this.archivoPDF = [];
      this.previewPDF = [];

      this.mostrarPDF = false;
    },

    previewPDFFile(file) {
      console.log("previewPDFFile", file);
      if (!file || file.length === 0) {
        this.previewPDF = [];
        return;
      }

      this.previewPDF = Array.from(file).map((pdfFile) => ({
        file: pdfFile,
        name: pdfFile.name,
      }));

      console.log("Archivos PDF seleccionados:", this.previewPDF);

      this.mostrarPDF = true;
      this.combinarPDFs();
    },

    async combinarPDFs() {
      if (!this.previewPDF || this.previewPDF.length === 0) return;

      const mergedPdf = await PDFDocument.create();

      for (const archivo of this.previewPDF) {
        const arrayBuffer = await archivo.file.arrayBuffer();
        const pdf = await PDFDocument.load(arrayBuffer);
        const copiedPages = await mergedPdf.copyPages(
          pdf,
          pdf.getPageIndices()
        );
        copiedPages.forEach((page) => mergedPdf.addPage(page));
      }

      const mergedPdfBytes = await mergedPdf.save();
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      this.unirPdfs = blob;
      this.pdfUrlPreview = URL.createObjectURL(blob);
      this.mostrarPDF = true;
    },

    cerrarDialogPDF() {
      this.dialogPDF = false;
      this.archivoPDF = [];
      this.previewPDF = [];

      this.mostrarPDF = false;
      this.currentItem = null;
    },

    async subirPDF() {
      console.log("pdf a enviar", this.unirPdfs);
      if (
        !this.previewPDF ||
        !this.currentItem ||
        !this.tipoPDF ||
        !this.unirPdfs
      )
        return;

      this.loadingPDF = true;
      try {
        const formData = new FormData();
        formData.append("file", this.unirPdfs, "unir.pdf");

        console.log("Datos antes de enviar al post", this.currentItem.id);
        const response = await axios.post(
          `/cuentas/asociar_pdf?uuid=${this.currentItem.id}&tipo=${this.tipoPDF}`,
          formData
        );

        console.log("Respuesta de pdf:", response.data);

        alert("PDF subido correctamente!");
        this.cerrarDialogPDF();
        this.obtenerCuentas();
      } catch (err) {
        console.error(err);
        alert("Error al subir el PDF");
      } finally {
        this.loadingPDF = false;
      }
    },

    async obtenerCuentas() {
      try {
        const response = await axios.get("/cuentas/get");
        const data = response.data;
        this.itemsSucursalesDisponibles = this.ordenSucursales
          .filter((nombre) => data[nombre])
          .map((nombre) => ({
            sucursal: nombre,
            cuentas: data[nombre],
          }));
      } catch (error) {
        console.error(error);
      }
    },

    PreviewXMLFile(file) {
      if (!file) {
        this.previewXML = null;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const xmlText = e.target.result;

          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(xmlText, "text/xml");

          const comprobante =
            xmlDoc.getElementsByTagName("cfdi:Comprobante")[0];

          if (!comprobante) {
            this.previewXML = null;
            alert("No es un CFDI válido");
            return;
          }

          const emisor = xmlDoc.getElementsByTagName("cfdi:Emisor")[0];

          const fechaCompleta = comprobante.getAttribute("Fecha");

          this.previewXML = {
            proveedor: emisor?.getAttribute("Nombre") || "Desconocido",
            folio: `${comprobante.getAttribute("Serie") || ""}-${
              comprobante.getAttribute("Folio") || ""
            }`,
            total: comprobante.getAttribute("Total"),
            fecha: fechaCompleta ? fechaCompleta.split("T")[0] : "",
          };
        } catch (e) {
          console.error(e);
          this.previewXML = null;
        }
      };

      reader.readAsText(file);
    },

    async cargarXML() {
      if (!this.archivoXML) {
        alert("Selecciona un archivo XML");
        return;
      }

      this.loading = true;

      try {
        const formData = new FormData();
        formData.append("file", this.archivoXML);
        console.log(
          "Datos antes de enviar al post",
          this.ordenDeCompra,
          this.sucursal
        );
        const response = await axios.post(
          `/cuentas/crear_cuenta?orden_de_compra=${this.ordenDeCompra}&sucursal=${this.sucursal}`,
          formData
        );
        console.log("Respuesta:", response.data);

        // Limpiar
        this.dialogXML = false;
        this.archivoXML = null;
        this.obtenerCuentas();

        this.loading = false;
      } catch (error) {
        console.error(error);
        alert("Error al leer el XML");
        this.loading = false;
      }
    },
    getProveedor(xmlDoc) {
      const emisor = xmlDoc.getElementsByTagName("cfdi:Emisor")[0];

      return emisor?.getAttribute("Nombre") || "Desconocido";
    },

    obtenerSucursalActual() {
      const nombreSucursal = this.ordenSucursales[this.selectedTab];
      console.log("Sucursal actual:", nombreSucursal);
      return this.sucursal[nombreSucursal] || {};
    },

    formatearPrecio(precio) {
      return precio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    async getUsuarios() {
      try {
        const response = await axios.get(`/usuarios/get_usuarios`);
        this.usuarios = response.data.usuarios;
      } catch (error) {
        console.error(error);
        return "Desconocido";
      }
    },

    getNombreUsuario(id) {
      const usuario = this.usuarios.find((u) => u.id === id);
      return usuario ? usuario.nombre : "Desconocido";
    },

    copiarAlPortapapeles(texto) {
      navigator.clipboard.writeText(texto).then(() => {
        this.alertaCopiado = true;
        setTimeout(() => {
          this.alertaCopiado = false;
        }, 2000);
      });
    },

    expandirItem(id) {
      this.$set(this.expandedIds, id, !this.expandedIds[id]);
    },
    cambiarEstatus(item) {
      if (item.value === true) {
        alert(`Estas seguro de cambiar a pagado la cuenta: ${item.id}?`);
      }
      try {
        axios.post(`/cuentas/pagar/${item.id}`);
        this.obtenerCuentas();
        alert("Cuenta marcada como pagada!");
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    ...mapGetters(["user", "currentUser"]),
    sucursalSeleccionada() {
      return this.itemsSucursalesDisponibles[this.selectedTab]?.sucursal || "";
    },
    itemRowBackground() {
      return (item) => {
        const estatus = item.pagado;
        switch (estatus) {
          case false:
            return "amber lighten-4";
          case true:
            return "green lighten-4";
          default:
            return "";
        }
      };
    },
  },
  watch: {
    selectedTab() {
      this.sucursal =
        this.itemsSucursalesDisponibles[this.selectedTab]?.sucursal || "";
      console.log("Sucursal actualizada:", this.sucursal);
    },
  },
  mounted() {
    this.getUsuarios();
    this.obtenerCuentas();
    // Inicializar sucursal con la primera pestaña
    this.sucursal =
      this.itemsSucursalesDisponibles[this.selectedTab]?.sucursal || "";
    console.log("Sucursal inicial:", this.sucursal);
  },
  async created() {},
  beforeDestroy() {},
  components: { VuePdfApp, CuentasPagadasView },
};
</script>

<style scoped>
.tamaño-select-estatus {
  width: 114px;
}

.color-bg-table td:first-child {
  white-space: normal !important;
  word-break: break-all;
  max-width: 250px;
}
.alerta-copiado {
  position: fixed;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  z-index: 9999;
  min-width: 260px;
}
</style>
